var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpend)?_c('div',{staticClass:"k-video"},[_c('div',{staticClass:"k-video-mask",on:{"click":_vm.onMaskClick}}),_c('div',{class:[
            'k-video-player',
            _vm.isLandscape && 'k-video-player--landscape'
        ]},[(_vm.info.id)?_c('video-player',{ref:"video",attrs:{"src":require(`@/assets/videos/${_vm.info.type}/${_vm.info.id}.mp4`),"options":_vm.playerOptions,"playsinline":true},on:{"canplay":function($event){return _vm.onCanPlay($event)}}}):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }